import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { WorkspaceSubmitButton } from '../../../containers/WorkspaceSubmitButton';
import { IUpdateWorkspaceTimeZoneBl } from '../UpdateWorkspaceTimeZone.bl';

export const UpdateWorkspaceTimeZoneSubmitButtonContainer = observer((): ReactElement => {
  const bl = useInjection(IUpdateWorkspaceTimeZoneBl.$);

  const handleSubmit = async (): Promise<void> => {
    await bl.submitFormAsync();
  };

  return (
    <WorkspaceSubmitButton
      disabled={false}
      onSubmit={handleSubmit}
      label='update_timezone'
    />
  );
});
